import { IGetAllItemChecklistServicoUseCase } from "../../../presentation/useCases/read/get_all_item_checklist_servico_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { ItemChecklistServico } from "../../models/item_checklist_servico";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetAllItemChecklistServicoUseCase
 */

export class GetAllItemChecklistServicoUseCase
  extends BasePaginatedUseCase<ItemChecklistServico>
  implements IGetAllItemChecklistServicoUseCase {
  constructor(private readonly repository: IObrasRepository) {
    super();
  }

  async getAllItemChecklistServico(
    idChecklistServicoAmbiente: number | undefined,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (idChecklistServicoAmbiente === undefined) throw new Error('Falha ao obter id de checklist de serviço!');

    const response = await this.repository.getAllItemChecklistServico(
      idChecklistServicoAmbiente,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
